import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import LoginModal from '@/components/feature/LoginModal';
import ScrollRevealObserver from '@/components/feature/ScrollRevealObserver';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  // Redirect already logged-in users to member panel
  useEffect(() => {
    if (!loading && user) {
      navigate('/member', { replace: true });
    }
  }, [user, loading, navigate]);

  const handleRegisterClick = () => {
    window.open('https://t.me/CarLandSupport', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-carland-light">
      <ScrollRevealObserver />
      <Navbar
        onLoginClick={() => setShowLoginModal(true)}
        onRegisterClick={handleRegisterClick}
      />
      <main>
        <HeroSection
          onLoginClick={() => setShowLoginModal(true)}
          onRegisterClick={handleRegisterClick}
        />
        <ServicesSection />
        <StatsSection />
        <AboutSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />

      {showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />}
    </div>
  );
}